<template>
    <div id="panel-time" class="panel">
        <div class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Інформація
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            
            <div class="panel-content">
                
                <div class="d-flex m-auto text-center flex-column pb-4" v-if="user.guest == 1">
                    <span class="l-h-n fs-md fw-500 opacity-70 text-danger">
                       Зареєструйтеся на сайті для участі в тендері
                    </span>
                </div>
                
                <div id="date_from"><div class="control-group">
                    <div class="control-label"><label id="jform_date_from-lbl" for="jform_date_from" class="inputname">
                        Початок тендера</label>
                    </div>
                    <div class="controls">
                        <div class="simple_text">
                            {{tender?.date_from}}
                        </div>
                    </div>
                </div>
                </div>
                <div id="date_to"><div class="control-group">
                    <div class="control-label"><label id="jform_date_to-lbl" for="jform_date_to" class="inputname">
                        Закінчення тендера</label>
                    </div>
                    <div class="controls">
                        <div class="simple_text">
                            {{tender?.date_to}}
                        </div>
                    </div>
                </div>
                </div>
                <div class="control-group">
                    <div class="control-label">
                        <label id="jform_cat_group_name-lbl" for="jform_cat_group_name" class="inputname">
                            Группа категорії закупки
                        </label>
                    </div>
                    <div class="controls">
                        <div class="simple_text">
                            {{tender?.main_categ.ua_name}}
                        </div>
                    </div>
                </div>
                <div class="control-group">
                    <div class="control-label"><label id="jform_category_name-lbl" for="jform_category_name" class="clcategorys">
                        Категорія закупки</label>
                    </div>
                    <div class="controls">
                        <div class="simple_text">
                            <span>{{ tender?.human_categories.map(i => i.title).join(' | ') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    name: "tender_info",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
    computed: {
        ...mapGetters({
            'user': "user/getUser",
        }),
    },
}
</script>



<style scoped>
.description.application {
    max-height: 220px;
    /* overflow-y: auto; */
}
</style>